var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    {
      staticClass:
        "showLargeScreenOnly d-flex justify-content-between p-4 h-120px",
      attrs: { type: "faded" },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c("b-navbar-brand", { staticClass: "py-4", attrs: { href: "#" } }, [
            _c("img", {
              staticClass: "heritage-web-header largescreen",
              staticStyle: { "margin-top": "0.2rem", width: "400px" },
              attrs: { src: _vm.imgVarsLong, alt: "DealPrudence" },
              on: { click: _vm.loadAccueil },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "div",
          { staticClass: "d-flex mr-4" },
          [
            _c(
              "b-navbar-nav",
              {
                key: _vm.resetMenu,
                staticClass: "m-auto text-light",
                attrs: { fill: "" },
              },
              _vm._l(_vm.menu, function (item, id) {
                return !_vm.isDisabledItem(item)
                  ? _c(
                      "span",
                      { attrs: { disabled: !item.enabled } },
                      [
                        item.list
                          ? _c(
                              "div",
                              {
                                on: {
                                  mouseover: function ($event) {
                                    return _vm.autoDropdown(
                                      true,
                                      "dropdown" + id
                                    )
                                  },
                                  mouseleave: function ($event) {
                                    return _vm.autoDropdown(
                                      false,
                                      "dropdown" + id
                                    )
                                  },
                                },
                              },
                              [
                                _vm.hasOneRight(item.list)
                                  ? _c(
                                      "b-nav-item-dropdown",
                                      {
                                        ref: "dropdown" + id,
                                        refInFor: true,
                                        staticClass:
                                          "h5 font-weight-bold dropDownInnerWebHeader p-1 p-xl-2 mt-3",
                                        class: {
                                          selectedMenuItemWebHeader:
                                            item.list.some(
                                              (e) => _vm.selectedMenu === e.link
                                            ),
                                        },
                                        attrs: {
                                          text: _vm.$t(item.title),
                                          "toggle-class": "text-menu",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                            },
                                            attrs: { slot: "button-content" },
                                            slot: "button-content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t(item.title))
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            item.list.some(
                                              (e) => _vm.selectedMenu === e.link
                                            )
                                              ? _c("div", {
                                                  staticClass:
                                                    "border-bottom pt-2 border-light position-absolute",
                                                  staticStyle: {
                                                    width: "calc(100% - 1rem)",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(item.list, function (subitem) {
                                          return !_vm.isDisabledItem(subitem) &&
                                            _vm.canShowSpecific(subitem)
                                            ? _c(
                                                "b-dropdown-item",
                                                {
                                                  key: subitem.id,
                                                  staticClass:
                                                    "dropdown-item-web-header mb-1",
                                                  class: {
                                                    selectedMenuItemWebHeader:
                                                      _vm.selectedMenu ===
                                                      subitem.link,
                                                    subItemMenuWebHeader:
                                                      subitem.id === 0,
                                                    subItemTextWebHeader:
                                                      subitem.id !== 0,
                                                  },
                                                  attrs: {
                                                    disabled: !subitem.enabled,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.getClicked(
                                                        subitem
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "pb-1",
                                                      class:
                                                        subitem.link ===
                                                        _vm.selectedMenu
                                                          ? "border-bottom border-success"
                                                          : "",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(subitem.title)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !subitem.link
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "disabled ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.dsbld"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : !_vm.isDisabledItem(item)
                          ? _c(
                              "b-nav-item",
                              {
                                staticClass:
                                  "h5 text-menu subItemTextOnlyWebHeader p-1 p-xl-2 mt-3 font-weight-bold",
                                class: {
                                  selectedMenuItemWebHeader:
                                    _vm.selectedMenu === item.link,
                                },
                                attrs: {
                                  disabled: !item.enabled,
                                  "link-classes": {
                                    borderSuccessMenu:
                                      _vm.selectedMenu === item.link,
                                  },
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.getClicked(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$t(item.title)) +
                                    "\n          "
                                ),
                                !item.link
                                  ? _c(
                                      "span",
                                      { staticClass: "disabled ml-1" },
                                      [_vm._v(_vm._s(_vm.$t("common.dsbld")))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.link === _vm.selectedMenu
                                  ? _c("div", {
                                      staticClass:
                                        "border-bottom pt-2 border-light position-absolute",
                                      staticStyle: {
                                        width: "calc(100% - 1rem)",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e()
              }),
              0
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center pl-1 border border-light shadow",
            staticStyle: { "border-radius": "20px" },
          },
          [
            _c(
              "b-navbar-nav",
              {
                staticClass: "px-0 px-lg-3 border-light",
                class: { "border-right": !_vm.flagTOOLBOX },
                attrs: { fill: "" },
              },
              [
                _c(
                  "div",
                  {
                    on: {
                      mouseover: function ($event) {
                        return _vm.autoDropdown(true, "log")
                      },
                      mouseleave: function ($event) {
                        return _vm.autoDropdown(false, "log")
                      },
                    },
                  },
                  [
                    this.$engine.user && this.$engine.user.userAccountId !== 1
                      ? _c(
                          "b-nav-item-dropdown",
                          {
                            ref: "log",
                            staticClass: "logOut",
                            attrs: {
                              "toggle-class": "d-flex align-items-center",
                              right: "",
                              variant: "link",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("img", {
                                        staticClass: "navbarProfileImage mr-2",
                                        attrs: { src: _vm.imgProfil, alt: "" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column align-items-start",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-none d-xl-inline mr-2 mb-0 text-menu text-light profile-menu font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.companyName) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-none d-xl-inline mr-2 mb-0 text-menu text-light profile-menu",
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(_vm.userName) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2343009730
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                staticClass:
                                  "subItemTextWebHeader dropdown-item-web-header",
                                on: {
                                  click: function ($event) {
                                    return _vm.goToLink("/profile/")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("leftPanelTitle.my_prfl")))]
                            ),
                            _vm._v(" "),
                            _vm.hasMultipleAccounts()
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    staticClass:
                                      "subItemTextWebHeader dropdown-item-web-header",
                                    on: { click: _vm.activateModalProfile },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("leftPanelTitle.swtch_prfl")
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$engine.rights.rightIs("settings_consult", true)
                              ? _c(
                                  "b-dropdown-item",
                                  {
                                    staticClass:
                                      "subItemTextWebHeader dropdown-item-web-header",
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToLink(
                                          "/settings/application/"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Webheader.settings")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                staticClass:
                                  "subItemTextWebHeader dropdown-item-web-header",
                                on: { click: _vm.logout },
                              },
                              [_vm._v(_vm._s(this.$t("leftPanelTitle.lgout")))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.flagTOOLBOX
              ? _c(
                  "b-navbar-nav",
                  { staticClass: "mx-0 mx-lg-3", attrs: { fill: "" } },
                  [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          right: "",
                          "toggle-class":
                            "border-0 p-0 bg-none m-md-2 text-dark bg-none-first-child",
                        },
                        model: {
                          value: _vm.language,
                          callback: function ($$v) {
                            _vm.language = $$v
                          },
                          expression: "language",
                        },
                      },
                      [
                        _c("template", { slot: "button-content" }, [
                          _vm.language === "FR"
                            ? _c("img", {
                                staticClass: "flag-nav",
                                attrs: { src: _vm.logoFlagFR, alt: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.language === "EN"
                            ? _c("img", {
                                staticClass: "flag-nav",
                                attrs: { src: _vm.logoFlagEN, alt: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.language === "GB"
                            ? _c("img", {
                                staticClass: "flag-nav",
                                attrs: { src: _vm.logoFlagEN, alt: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.language === "DE"
                            ? _c("img", {
                                staticClass: "flag-nav",
                                attrs: { src: _vm.logoFlagDE, alt: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.language === "IT"
                            ? _c("img", {
                                staticClass: "flag-nav",
                                attrs: { src: _vm.logoFlagIT, alt: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.language === "ES"
                            ? _c("img", {
                                staticClass: "flag-nav",
                                attrs: { src: _vm.logoFlagES, alt: "" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.language === "PT"
                            ? _c("img", {
                                staticClass: "flag-nav",
                                attrs: { src: _vm.logoFlagPT, alt: "" },
                              })
                            : _vm._e(),
                          _c("span", { staticClass: "text-light" }, [
                            _vm._v(_vm._s(_vm.labelLanguage)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.options, function (option) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: option.value,
                              staticClass: "dropdown-item-web-header",
                              on: {
                                click: function ($event) {
                                  return _vm.languageCountry(option.value)
                                },
                              },
                            },
                            [
                              option.value === "FR"
                                ? _c("img", {
                                    staticClass: "flag-nav",
                                    attrs: { src: _vm.logoFlagFR, alt: "" },
                                  })
                                : option.value === "GB"
                                ? _c("img", {
                                    staticClass: "flag-nav",
                                    attrs: { src: _vm.logoFlagEN, alt: "" },
                                  })
                                : option.value === "DE"
                                ? _c("img", {
                                    staticClass: "flag-nav",
                                    attrs: { src: _vm.logoFlagDE, alt: "" },
                                  })
                                : option.value === "IT"
                                ? _c("img", {
                                    staticClass: "flag-nav",
                                    attrs: { src: _vm.logoFlagIT, alt: "" },
                                  })
                                : option.value === "ES"
                                ? _c("img", {
                                    staticClass: "flag-nav",
                                    attrs: { src: _vm.logoFlagES, alt: "" },
                                  })
                                : option.value === "PT"
                                ? _c("img", {
                                    staticClass: "flag-nav",
                                    attrs: { src: _vm.logoFlagPT, alt: "" },
                                  })
                                : _c("img", {
                                    staticClass: "flag-nav",
                                    attrs: { src: _vm.logoFlagEN, alt: "" },
                                  }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(option.text))]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }